import React from "react";
import './Offer.css'
function  Offer () {
    return (
    <>
        <div className="Offer1">
        <h2> Offer Coming Soon.....</h2> 
        </div> 
    </>
    )   
}
export default Offer;